import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],class:{'eewc-loading-spinner' : _vm.absolute}},[_c(VProgressCircular,{staticClass:"eewc-loading-spinner__circle",attrs:{"color":_vm.color,"value":20,"size":_vm.size,"width":_vm.size / 15}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }